import httpService from './httpService';

export interface IInvestor {
  objectId: number;
  name: string;
  id: number;
  legalName: string;
  emailAddress: string;
  phoneNumber: string;
  postalAddress: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

export const getInvestors = (): Promise<IInvestor[]> => {
  let endpoint = httpService.getEndpointURL('/Investors');
  return httpService.get(endpoint).then((res) => res.data);
};

export const getActiveInvestors = (): Promise<IInvestor[]> => {
  let endpoint = httpService.getEndpointURL('/Investors?activeOnly=true');
  return httpService.get(endpoint).then((res) => res.data);
};

export const getInvestor = (id: number) => {
  let endpoint = httpService.getEndpointURL(`/Investors/${id}`);
  return httpService.get(endpoint).then((res) => res.data);
};

export const getInvestorAssociations = (id: number) => {
  let endpoint = httpService.getEndpointURL(`/Investors/${id}/associations`);

  return httpService.get(endpoint).then((res) => res.data);
};
